<template>
  <div>
    <mood-line-graph
      class="insetGraph"
      v-if="$store.state.user.scope"
      :userId="$store.state.user.scope.user_id"
    >
    </mood-line-graph>


    <mu-row gutter v-if="$store.state.user.scope" class="content">
      <mu-col desktop="30" tablet="50">
        <mood-input class="card-spacing" style="margin-top: 24px"></mood-input>
        <tracking-notifier
          :userId="$store.state.user.scope.user_id"
        ></tracking-notifier>
      </mu-col>
      <mu-col desktop="70" tablet="50">
        <mu-card
          style="margin-top: 24px;"
          id="blood-glucose-data"
          class="tracking-data"
        >
          <mu-card-text>
            <p class="tracking-subtext" v-text="$t('message.trackingHelpText')"></p>
          </mu-card-text>
          <mu-timeline>
            <div v-for="group, groupKey in groupFilter()" :key="'group-key-' + groupKey" style="margin-bottom: 16px;">
              <div v-for="titleItem, titleIndex in group" v-if="titleIndex === 0" class="timelineSpacing">
                <div class="bold timelineTitle"
                     v-text="groupedDateFormat(titleItem.date_created)">
                </div>
              </div>
              <div v-for="item, index in group" class="timelineSpacing" :key="'tracking-timeline-item-' + index" v-bind:class="{notEditMode: !item.isEditMode}">
                <mu-timeline-item
                  :key="'tl-' + index"
                  :iconColor="btnColor"
                  iconLine="8"
                  iconType="solid"
                  @click.native="showItemControls(item)"
                >
                  <mu-row>
                    <mu-col>
                      <div class="trackingDate" v-if="!item.isEditMode"
                           v-text="groupedItemDate(item.date_created)"></div>

                      <div v-text="$t(localizeMood(item.mood))"></div>
                    </mu-col>
                    <mu-col>
                      <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}"
                           class="reading"
                      >
                        <img :src="item.icon" width="32"/>
                      </div>
                    </mu-col>
                  </mu-row>
                  <div v-if="item.isControlsVisible && !item.isEditMode" align="right">
                    <mu-flat-button
                      :color="btnColor"
                      :label="$t('message.deleteText')"
                      icon="delete"
                      @click.native="deleteReading(item)"
                    ></mu-flat-button>
                  </div>
                </mu-timeline-item>
              </div>
            </div>
          </mu-timeline>
          <mu-card-text align=" center" v-if="isReadingsLoading">
            <mu-circular-progress color="#0179d5"></mu-circular-progress>
            <div>One sec...</div>
          </mu-card-text>
          <div v-if="!isReadingsLoading" ref="detector"></div>
        </mu-card>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>

  import TrackingDetailMixin from '../../mixins/TrackingDetailMixin'

  let fromDate = moment().subtract(1, 'month');
  let toDate = moment();

  import MoodApi from '../../api/Tracking/Mood'
  import MoodInput from "../../components/Tracking/Input/Mood/Mood";
  import MoodLineGraph from "../../components/Tracking/Graphs/Mood/LineGraph";
  import MoodLocalizerMixin from '../../mixins/Localization/Moods/MoodLocalizerMixin'
  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier.vue";

  export default {
    mixins: [TrackingDetailMixin, MoodLocalizerMixin],
    components: {
      TrackingNotifier,
      MoodLineGraph,
      MoodInput
    },
    data() {
      return {
        btnColor: '#302ca9'
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/tracking/mood');
      self.loadData();
      self.$EventBus.$on('moodPusherReceived', function () {
        self.loadData();
      });
    },
    methods: {
      deleteReading(reading) {
        let self = this;
        let swal = self.$alert;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveMoodItem'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return MoodApi.deleteMoodTracking(reading.progress_id, reading.tracking_id)
          }
        })
          .then(function (response) {
            let index = self.data.data.indexOf(reading);
            self.data.data.splice(index, 1);
            self.$alert({
              title: self.$t('message.labelSuccess'),
              text: self.$t('message.confirmedRemoveMoodItem'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            });
          }.bind(self))
          .catch(self.$alert.noop)
      },
      loadData() {
        let self = this;
        MoodApi.getMoodTrackingDetail(1, 15)
          .then(function (response) {
            self.isReadingsLoading = false;
            self.data = response.data;
          })
      },
      loadMoreData() {
        let self = this, page = self.data.page, pages = self.data.pages;
        if (page >= pages) {
          self.isReadingsLoading = false;
          return;
        }
        if ((page < pages)) {
          self.isReadingsLoading = true;
          page++;
          MoodApi.getMoodTrackingDetail(page, 15)
            .then(function (response) {
              self.data.page = response.data.page;
              self.data.data.push.apply(self.data.data, response.data.data);
              self.isReadingsLoading = false;
            })
        }
      },
      groupedDateFormat(date) {
        let self = this;
        return moment(date).format('dddd Do  MMMM YYYY');
      },
      /**
       * Format grouped date title
       * @param date
       * @returns {string}
       */
      groupedItemDate(date) {
        let offset = new Date();
        let dateMod = moment.utc(date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
        return dateMod.format('hh:mm a') + ' on ' + dateMod.format('dddd Do');
      },
      /**
       * Filter the list to group by day
       * @returns {Observable<GroupedObservable<K, R>>|*|Observable.<GroupedObservable.<K, R>>}
       */
      groupFilter() {
        let self = this;
        return _.groupBy(self.data.data, function (reading) {
          return moment(reading.date_created).startOf('day').format();
        })
      },
    },
    beforeDestroy() {
      this.$EventBus.$off('moodPusherReceived');
      this.$EventBus.$off('moodReadingAdded');
    }
  }
</script>
<style scoped lang="less">


  @bgBranding: #183A43;

  .timelineSpacing.notEditMode:hover {
    background: fade(@bgBranding, 10%);
    cursor: pointer;
  }

  .whiteTitle {
    font-size: 18px !important;
    color: white !important;

  }
</style>



// WEBPACK FOOTER //
// Mood.vue?fcc35998